var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.serviceAccountLink)?_c('nuxt-link',{attrs:{"to":_vm.serviceAccountLink}},[_vm._v("\n  "+_vm._s(_vm.typeDisplay)+"\n")]):_c('div',[_vm._v("\n  "+_vm._s(_vm.typeDisplay)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }